import { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import axios from "axios";
import MDBox from "admin/components/MDBox";
import MDTypography from "admin/components/MDTypography";
import DashboardLayout from "admin/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "admin/examples/Navbars/DashboardNavbar";

const API = process.env.REACT_APP_APIHOST || "http://localhost:3033";

function AutomatedRoutines() {
    const [routines, setRoutines] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => { fetchRoutines(); const t = setInterval(fetchRoutines, 15000); return () => clearInterval(t); }, []);

    const fetchRoutines = async () => {
        try {
            const r = await axios.get(API + "/cron-status");
            if (r.data.status) setRoutines(r.data.data);
        } catch(e) {}
        finally { setLoading(false); }
    };

    const statusIcon = (s) => {
        if (s === 'running') return { icon: 'sync', color: '#C29717', spin: true };
        if (s === 'success') return { icon: 'check_circle', color: '#4CAF50', spin: false };
        if (s === 'failed') return { icon: 'error', color: '#e55', spin: false };
        return { icon: 'schedule', color: '#888', spin: false };
    };

    const timeAgo = (d) => {
        if (!d) return 'never';
        const ms = Date.now() - new Date(d).getTime();
        const m = Math.floor(ms / 60000);
        if (m < 1) return 'just now';
        if (m < 60) return m + 'min ago';
        const h = Math.floor(m / 60);
        if (h < 24) return h + 'h ' + (m % 60) + 'min ago';
        const days = Math.floor(h / 24);
        return days + 'd ' + (h % 24) + 'h ago';
    };

    const timeUntil = (d) => {
        if (!d) return '-';
        const ms = new Date(d).getTime() - Date.now();
        if (ms < 0) return 'overdue';
        const m = Math.floor(ms / 60000);
        if (m < 1) return 'imminent';
        if (m < 60) return 'in ' + m + 'min';
        const h = Math.floor(m / 60);
        if (h < 24) return 'in ' + h + 'h ' + (m % 60) + 'min';
        return 'in ' + Math.floor(h / 24) + 'd ' + (h % 24) + 'h';
    };

    const scheduleLabel = (s) => {
        if (s === '*/3 * * * *') return 'Every 3 minutes';
        if (s === '0 0 * * *') return 'Daily at midnight';
        if (s === '0 3 * * *') return 'Daily at 3:00 AM';
        return s || '-';
    };

    const routineIcon = (name) => {
        if (name.toLowerCase().includes('crawl')) return 'radar';
        if (name.toLowerCase().includes('backup')) return 'backup';
        if (name.toLowerCase().includes('ai') || name.toLowerCase().includes('scanner')) return 'smart_toy';
        return 'settings';
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={2} pb={2}>
                <Card>
                    <MDBox px={2} pt={1} pb={0.5} display="flex" justifyContent="space-between" alignItems="center">
                        <MDTypography variant="body2" sx={{ color: "#C29717", fontSize: "11px", textTransform: "uppercase", letterSpacing: "1.5px" }}>
                            Automated routines ({routines.length})
                        </MDTypography>
                        <MDTypography component="span" sx={{ color: "#888", fontSize: "10px" }}>
                            Auto-refresh 15s
                        </MDTypography>
                    </MDBox>

                    <MDBox px={2} py={1}>
                        {loading ? (
                            <MDBox display="flex" justifyContent="center" p={3}><div className="forte-spin" style={{margin:"0 auto"}}></div></MDBox>
                        ) : routines.length === 0 ? (
                            <MDTypography sx={{ color: "#888", fontSize: "13px", py: 2, textAlign: "center" }}>No routines tracked yet. They will appear after first execution.</MDTypography>
                        ) : routines.map(r => {
                            const si = statusIcon(r.status);
                            return (
                                <MDBox key={r._id} sx={{ borderBottom: "1px solid rgba(255,255,255,0.04)", py: 1.5 }}>
                                    <MDBox display="flex" justifyContent="space-between" alignItems="flex-start">
                                        <MDBox display="flex" gap={1.5} alignItems="center">
                                            <Icon sx={{ fontSize: "20px !important", color: si.color, animation: si.spin ? 'spin 2s linear infinite' : 'none', '@keyframes spin': { '0%': { transform: 'rotate(0deg)' }, '100%': { transform: 'rotate(360deg)' } } }}>{si.icon}</Icon>
                                            <MDBox>
                                                <MDBox display="flex" gap={1} alignItems="center" mb={0.3}>
                                                    <Icon sx={{ fontSize: "14px !important", color: "#888" }}>{routineIcon(r.name)}</Icon>
                                                    <span style={{color:'#fff',fontSize:'13px',fontWeight:500}}>{r.name}</span>
                                                    <span style={{fontSize:'9px',color:si.color,textTransform:'uppercase',background:'rgba(255,255,255,0.04)',borderRadius:'2px',padding:'1px 6px'}}>{r.status}</span>
                                                </MDBox>
                                                <MDBox display="flex" gap={1.5} fontSize="10px" color="#888" mb={0.3}>
                                                    <span><Icon sx={{ fontSize: "10px !important", verticalAlign: "middle", mr: 0.3 }}>schedule</Icon>{scheduleLabel(r.schedule)}</span>
                                                    <span>Runs: {r.runCount || 0}</span>
                                                </MDBox>
                                            </MDBox>
                                        </MDBox>
                                        <MDBox textAlign="right">
                                            {r.nextRun && (
                                                <MDBox fontSize="11px" mb={0.3}>
                                                    <span style={{color:'#888'}}>Next: </span>
                                                    <span style={{color: new Date(r.nextRun) < new Date() ? '#e55' : '#7a9ec2'}}>{timeUntil(r.nextRun)}</span>
                                                </MDBox>
                                            )}
                                        </MDBox>
                                    </MDBox>
                                    <MDBox display="flex" gap={2} mt={0.5} ml={4.5} fontSize="10px">
                                        <MDBox>
                                            <span style={{color:'#666'}}>Last run: </span>
                                            <span style={{color:'#aaa'}}>{timeAgo(r.lastRun)}</span>
                                        </MDBox>
                                        <MDBox>
                                            <span style={{color:'#666'}}>Last success: </span>
                                            <span style={{color: r.lastSuccess ? '#4CAF50' : '#888'}}>{timeAgo(r.lastSuccess)}</span>
                                        </MDBox>
                                        {r.lastError && (
                                            <MDBox>
                                                <span style={{color:'#e55'}}>Error: {r.lastError}</span>
                                            </MDBox>
                                        )}
                                    </MDBox>
                                </MDBox>
                            );
                        })}
                    </MDBox>
                </Card>
            </MDBox>
        </DashboardLayout>
    );
}
export default AutomatedRoutines;
